<template>
  <div class="layout">
    <div :class="['header', { 'no-scroll': isHome }]">
      <HeaderNavigation />
      <router-view />
    </div>
    <div class="footer">
      <FooterNavigation />
    </div>
  </div>
</template>

<script>
import HeaderNavigation from "@/components/HeaderNavigation.vue";
import FooterNavigation from "@/components/FooterNavigation.vue";

export default {
  name: "DefaultLayout",
  components: { HeaderNavigation, FooterNavigation },
  computed: {
    isHome() {
      return this.$route.name === "home";
    },
  },
};
</script>
